/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useRegisteredPayers
 */
import _ from 'lodash';
import { AxiosRequestConfig } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import api from 'client/index';
import { prepareAllPayersMeta } from 'utils/admin/payers';
import QUERY_KEYS from 'app-constants/queryKeys';

const getOnboardingHeaders = (onBoarding?: boolean): AxiosRequestConfig<AnyType> | undefined => {
	if (onBoarding) {
		return { headers: { onboarding: true } };
	}
};

/**
 * useRegisteredPayers hook
 * @returns {UseQueryResult} useRegisteredPayers
 */
const useRegisteredPayers = (onBoarding?: boolean): UseQueryResult<Payers.IRegisteredPayer[]> => {
	return useQuery({
		queryKey: [QUERY_KEYS.registeredPayers, onBoarding],
		queryFn: async () => {
			const { data } = await api.EZAPIPayersApi.getEZAPIPayers(getOnboardingHeaders(onBoarding));
			return _.orderBy(prepareAllPayersMeta(data), 'name');
		},
		refetchOnMount: false,
		refetchInterval: 1000 * 60 * 60 * 24, // 24 hours
	});
};

export { getOnboardingHeaders };
export default useRegisteredPayers;
